import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import UserMenu from './menu/UserMenu';
import { useState } from 'react';

const UserAvatar = ({ user }) => {
  const [anchorElUser, setAnchorElUser] = useState(null);
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const getUserInitial = () => {
    if (user?.displayName) {
      return user.displayName.charAt(0).toUpperCase();
    }
    if (user?.email) {
      return user.email.charAt(0).toUpperCase();
    }
    return 'U';
  };

  return (
    <div className="user-avatar">
      {user && (
        <Box sx={{ flexGrow: 0 }}>
          <Tooltip title="Open settings">
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar alt={user?.displayName || user?.email || 'User'} src={user?.photoURL}>
                {!user?.photoURL && getUserInitial()}
              </Avatar>
            </IconButton>
          </Tooltip>

          {/* User Menu */}
          <UserMenu
            user={user}
            anchorElUser={anchorElUser}
            handleCloseUserMenu={handleCloseUserMenu}
            getUserInitial={getUserInitial}
          />
        </Box>
      )}

      <style jsx>{`
        .user-avatar {
          width: 36px;
          height: 36px;
          background: #f6f6f6;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 16px;
          color: #222;
        }
      `}</style>
    </div>
  );
};

export default UserAvatar;
